var _path, _path2, _path3, _circle, _circle2, _circle3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 20 L85 20 L85 25 L55 45 L55 75 L45 80 L45 45 L15 25 Z",
    fill: "none",
    stroke: "#2563eb",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "funnelGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6",
      stopOpacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1d4ed8",
      stopOpacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lightningGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#fbbf24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f59e0b"
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20 L85 20 L85 25 L55 45 L55 75 L45 80 L45 45 L15 25 Z",
    fill: "url(#funnelGradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32 L45 32 L40 42 L48 42 L42 55 L38 48 L32 48 L35 32 Z",
    fill: "url(#lightningGradient)",
    stroke: "#f59e0b",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 35,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 38,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 50,
    r: 1.5,
    fill: "#f59e0b",
    opacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62 L52 62 L50 67 L54 67 L51 73 L49 70 L46 70 L48 62 Z",
    fill: "#fbbf24",
    stroke: "#f59e0b",
    strokeWidth: 0.5,
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickFilterIcon);
export default __webpack_public_path__ + "static/media/QuickFilterIcon.33ae87b472eaee025ac8e28263853390.svg";
export { ForwardRef as ReactComponent };